import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const BonusTableListItemExpandDescription = ({ bonus }) => {
  const { description } = bonus;

  const renderDescriptionFunc = useMemo(() => {
    if (description) {
      return <div className="bonus-description title-small-300-text">{description}</div>;
    }
  }, [description]);

  return <>{renderDescriptionFunc}</>;
};

BonusTableListItemExpandDescription.propTypes = {
  bonus: PropTypes.object.isRequired,
};

export default BonusTableListItemExpandDescription;
